import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { PaymentDetailFieldProps } from "./types";

/**
 * PaymentDetailField component
 *
 * A reusable component for displaying label-value pairs in a consistent format
 * Used in various review steps across different payee workflows
 */
export const PaymentDetailField: React.FC<PaymentDetailFieldProps> = ({
  label,
  value = "",
  valueChildren,
}) => (
  <Flex>
    <Flex flexBasis="25%">
      <Text variant="secondary-md">{label}</Text>
    </Flex>
    <Flex flexBasis="75%" flexDirection="column">
      <Text variant="regular-md">{value}</Text>
      {valueChildren && <div>{valueChildren}</div>}
    </Flex>
  </Flex>
);

export default PaymentDetailField;
